import * as React from 'react';
import { getHighlighter } from 'shiki';
import type { LanguageRegistration } from 'shiki';

import darkTheme from './themes/dark.json';
import lightTheme from './themes/light.json';
import styledLang from './langs/styled';
import cssStyledLang from './langs/css-styled';
import { CLIENT_LANGUAGES } from './CodeSnippet.types';
import type {
  Highlighter,
  ClientLanguage,
} from './CodeSnippet.types';

let highlighter: Highlighter = null;

// NOTE: I was originally going to lazy-load `styledLang` and `cssStyledLang`, but ultimately, the entire client-side code snippet is lazy-loaded, and these two files don't add too much heft.
// Also: I used to only have the "dark" color theme, but the "light" theme only adds ~2.5kb gzip, and it feels weird in blog posts that have other server-rendered light snippets to have some randomly be dark.
const LANGUAGES: Array<ClientLanguage | LanguageRegistration> = [
  styledLang,
  cssStyledLang,
  ...CLIENT_LANGUAGES,
];

const getCachedHighlighter = React.cache(async () => {
  if (highlighter === null) {
    highlighter = await getHighlighter({
      // @ts-ignore
      themes: [lightTheme, darkTheme],
      langs: LANGUAGES,
    });
  }

  return highlighter;
});

export default getCachedHighlighter;
